var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scroll-close',[_c('v-tooltip',_vm._b({},'v-tooltip',_vm.$attrs,false),[(!_vm.$slots.activator)?[_c('sup',{attrs:{"slot":"activator"},slot:"activator"},[_c('nt-icon',{attrs:{"small":"","color":"grey lighten-1"}},[_vm._v("*")])],1)]:[_vm._t("activator",null,{"slot":"activator"})],_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }